import React from 'react';
import { CheckCircle2Icon, LockIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
import { CONSTANTS } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { PaymentBadges } from './PaymentBadges';
export const OfferSection: React.FC = () => {
  const handlePurchase = () => {
    window.open(CONSTANTS.PAYMENT_LINK, '_blank');
  };
  return <section id="oferta" className="py-20 px-4 bg-gradient-to-b from-gray-50 to-white scroll-mt-20" data-id="element-122">
      <div className="max-w-4xl mx-auto" data-id="element-123">
        <div className="text-center mb-12" data-id="element-124">
          <h2 className="text-3xl md:text-5xl font-extrabold text-gray-900 mb-4" data-id="element-125">
            Accedé ahora al Pack Completo
          </h2>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden relative" data-id="element-126">
          {/* Header */}
          <div className="bg-green-500 text-white text-center py-4 font-bold text-xl tracking-wide" data-id="element-127">
            PACK COMPLETO — Sistema del Entrenador Profesional
          </div>

          <div className="p-6 md:p-10" data-id="element-128">
            <div className="flex flex-col md:flex-row gap-8 items-center mb-8" data-id="element-129">
              <div className="w-full md:w-1/2" data-id="element-130">
                <img src={CONSTANTS.IMAGES.COMBO} alt="Combo Completo" className="w-full h-auto drop-shadow-xl" data-id="element-131" />
              </div>

              <div className="w-full md:w-1/2 space-y-3" data-id="element-132">
                <h3 className="font-bold text-xl mb-4 border-b pb-2" data-id="element-133">
                  Incluye:
                </h3>

                <div className="flex items-center justify-between" data-id="element-134">
                  <div className="flex items-center gap-2" data-id="element-135">
                    <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-136" />
                    <span className="font-medium" data-id="element-137">Megapack Fútbol</span>
                  </div>
                  <span className="text-gray-500" data-id="element-138">
                    ${CONSTANTS.PRICING.INDIVIDUAL_VALUE}
                  </span>
                </div>

                {['50 Sesiones Listas', 'Sistema del Entrenador Inteligente', 'Planes y Tácticas Reales', 'Errores y Ejercicios', 'Plan Semanal Completo', 'Guía desde Cero'].map((item, i) => <div key={i} className="flex items-center justify-between" data-id="element-139">
                    <div className="flex items-center gap-2" data-id="element-140">
                      <CheckCircle2Icon className="w-5 h-5 text-green-500 flex-shrink-0" data-id="element-141" />
                      <span className="text-gray-700" data-id="element-142">{item}</span>
                    </div>
                    <div className="flex items-center gap-2" data-id="element-143">
                      <span className="text-gray-400 line-through text-xs" data-id="element-144">
                        ${CONSTANTS.PRICING.BONUS_VALUE}
                      </span>
                      <span className="bg-red-100 text-red-700 text-[10px] font-bold px-2 py-0.5 rounded uppercase" data-id="element-145">
                        Gratis
                      </span>
                    </div>
                  </div>)}
              </div>
            </div>

            <div className="border-t border-gray-200 pt-8 mb-8 text-center" data-id="element-146">
              <div className="flex justify-center items-center gap-4 mb-2" data-id="element-147">
                <span className="text-gray-400 line-through text-2xl decoration-red-500 decoration-2" data-id="element-148">
                  ${CONSTANTS.PRICING.ORIGINAL.toLocaleString('es-AR')}
                </span>
                <span className="bg-green-100 text-green-800 font-bold px-3 py-1 rounded-full text-sm" data-id="element-149">
                  Ahorrás {CONSTANTS.PRICING.SAVINGS_PERCENTAGE}%
                </span>
              </div>

              <div className="flex justify-center items-start gap-1 mb-6" data-id="element-150">
                <span className="text-3xl font-bold text-gray-500 mt-2" data-id="element-151">$</span>
                <span className="text-6xl md:text-7xl font-extrabold text-gray-900 tracking-tight" data-id="element-152">
                  {CONSTANTS.PRICING.SALE.toLocaleString('es-AR')}
                </span>
              </div>

              <div className="flex justify-center mb-8" data-id="element-153">
                <CountdownTimer variant="dark" data-id="element-154" />
              </div>

              <button onClick={handlePurchase} className="w-full bg-green-500 hover:bg-green-600 text-white text-2xl font-bold py-6 px-8 rounded-2xl shadow-[0_10px_20px_rgba(34,197,94,0.3)] hover:shadow-[0_15px_30px_rgba(34,197,94,0.4)] transition-all transform hover:-translate-y-1 animate-pulse-fast" data-id="element-155">
                COMPRAR AHORA — $
                {CONSTANTS.PRICING.SALE.toLocaleString('es-AR')}
              </button>

              <div className="mt-4" data-id="element-156">
                <PaymentBadges data-id="element-157" />
              </div>
              <div className="mt-4 flex justify-center items-center gap-2 text-sm font-medium text-gray-600" data-id="element-158">
                <LockIcon className="w-4 h-4 text-green-600" data-id="element-159" />
                <span data-id="element-160">Compra 100% segura</span>
                <span className="mx-2" data-id="element-161">•</span>
                <span data-id="element-162">2.847+ entrenadores ya lo tienen</span>
              </div>
            </div>

            <div className="bg-green-50 rounded-xl p-6 grid grid-cols-1 md:grid-cols-3 gap-6 mb-8" data-id="element-163">
              <div className="flex flex-col items-center text-center gap-2" data-id="element-164">
                <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-165">
                  <LockIcon className="w-6 h-6 text-green-600" data-id="element-166" />
                </div>
                <h4 className="font-bold text-sm" data-id="element-167">Transacción Segura</h4>
                <p className="text-xs text-gray-600" data-id="element-168">
                  Protegido con encriptación SSL de 256 bits
                </p>
              </div>

              <div className="flex flex-col items-center text-center gap-2" data-id="element-169">
                <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-170">
                  <ShieldIcon className="w-6 h-6 text-green-600" data-id="element-171" />
                </div>
                <h4 className="font-bold text-sm" data-id="element-172">Garantía 30 Días</h4>
                <p className="text-xs text-gray-600" data-id="element-173">
                  Satisfecho o te devolvemos el dinero. Sin riesgo.
                </p>
              </div>

              <div className="flex flex-col items-center text-center gap-2" data-id="element-174">
                <div className="bg-white p-3 rounded-full shadow-sm" data-id="element-175">
                  <CreditCardIcon className="w-6 h-6 text-green-600" data-id="element-176" />
                </div>
                <h4 className="font-bold text-sm" data-id="element-177">Pago Único</h4>
                <p className="text-xs text-gray-600" data-id="element-178">
                  Sin suscripción. Sin costos ocultos.
                </p>
              </div>
            </div>

            <div className="bg-gray-50 border border-gray-200 rounded-xl p-6" data-id="element-179">
              <h3 className="font-bold text-lg text-center mb-4 text-gray-800" data-id="element-180">
                ¿Qué pasa después de la compra?
              </h3>
              <div className="flex flex-col md:flex-row gap-4 justify-center" data-id="element-181">
                <div className="flex-1 flex flex-col items-center text-center" data-id="element-182">
                  <div className="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold mb-2" data-id="element-183">
                    1
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-184">Hacé click en comprar</p>
                </div>
                <div className="flex-1 flex flex-col items-center text-center" data-id="element-185">
                  <div className="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold mb-2" data-id="element-186">
                    2
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-187">
                    Completá el pago seguro
                  </p>
                </div>
                <div className="flex-1 flex flex-col items-center text-center" data-id="element-188">
                  <div className="w-8 h-8 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center font-bold mb-2" data-id="element-189">
                    3
                  </div>
                  <p className="text-sm text-gray-700" data-id="element-190">
                    Recibí todo por email al instante
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};